import { useMutation, UseMutationConfig } from '@libs/use';
import { CreateTokenRequest, CreateTokenResponse } from '@libs/api-reference';

import * as API from '../requests';
import { openGateway, paymentTokenFactory } from '../utils/payment';
import { AP_URL } from '../constants';

export default function useCreateApPaymentTokenQuery({
  onReject,
}: {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onReject?: UseMutationConfig<{}>['onReject'];
} = {}) {
  const {
    execute: createApPaymentToken,
    isPending: isCreatingApPaymentToken,
    ...query
  } = useMutation<CreateTokenResponse>(
    (data: CreateTokenRequest) => {
      return API.createApPaymentToken(paymentTokenFactory(data));
    },
    {
      onReject,
      onSuccess(result) {
        if (result?.data) {
          openGateway({ ...result.data, gateway: AP_URL });
        }
      },
    }
  );

  return { createApPaymentToken, isCreatingApPaymentToken, ...query };
}
